<template lang="pug">
  .container.grid-xl
    page-title(icon="fas fa-shapes" :title="title" :subtitle="subtitle")
    .flex-centered.full-height(v-if="error") #[error-box(:error="error")]
    fieldset(v-else :disabled="loading")
      form(@submit.prevent="onSubmit")
        .columns
          .column.col-6.col-lg-7.col-md-8.col-sm-12
            .columns
              .column.col-12
                form-group(label="Título" :validation="$v.plan" field="title")
                  input.form-input(v-model.trim="$v.plan.title.$model")
              .column.col-12
                form-group(label="Descrição" :validation="$v.plan" field="description")
                  textarea.form-input(rows="5" v-model.trim="$v.plan.description.$model")
              .divider.col-12.text-center(data-content="Detalhes da cobrança")
              .column.col-4.col-sm-12
                form-group(label="Valor" :validation="$v.plan" field="price")
                  masked-money.form-input(v-model="$v.plan.price.$model" prefix="R$ ")
              .column.col-4.col-sm-12
                form-group(label="Tipo de intervalo" :validation="$v.plan" field="intervalType")
                  select.form-select(v-model="$v.plan.intervalType.$model")
                    option(v-for="intervalType in intervalTypes" :value="intervalType") {{ intervalType | planIntervalType }}
              .column.col-4.col-sm-12
                form-group(label="Intervalos" :validation="$v.plan" field="intervalCount")
                  input.form-input(type="number" min="1" v-model.number="$v.plan.intervalCount.$model")
              .column.col-8.col-sm-12(v-if="requiredBillingTriggeType")
                form-group(label="Gatilho para cobrança" :validation="$v.plan" field="billingTriggerType")
                  select.form-select(v-model="$v.plan.billingTriggerType.$model")
                    option(v-for="billingTriggerType in billingTriggerTypes" :value="billingTriggerType") {{ billingTriggerType | billingTriggerType }}
              .column.col-4.col-sm-12
                form-group(label="Dia da cobrança" :validation="$v.plan" field="billingTriggerDay")
                  input.form-input(type="number" min="0" max="31" v-model.number="$v.plan.billingTriggerDay.$model")
              .divider.col-12
              .column.col-12
                form-group(label="Coleções do plano")
                  collections-autocomplete(v-model="plan.collections")
              .divider.col-12
              .column.col-12
                form-switch(v-model="plan.monetizationForFiliations" label="Monetizar os produtores de conteúdo com assinaturas deste plano")
              .column.col-12
                form-switch(v-model="plan.isManualPayment" :disabled="Boolean(this.$route.params.id)" label="Plano para pagamentos externos" :help="isManualPaymentHelpLabel")
              .column.col-12
                form-switch(v-model="plan.requiresAddress" do label="Pedir o endereço do assinante" :help="requiresAddressHelpLabel")
              .divider.col-12
              .column.col-12.text-right
                button.btn.btn-primary(:disabled="disabled") Salvar
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import plans from '@/services/plans'
import requiredIf from 'vuelidate/lib/validators/requiredIf'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('systemParameters', ['systemParameters']),

    disabled() {
      return this.loading || this.$v.$invalid
    },
    title() {
      return this.$route.params.id ? 'Editar plano' : 'Novo plano'
    },
    subtitle() {
      return 'Planos para seus assinantes'
    },
    isManualPaymentHelpLabel() {
      return 'Plano usado para liberar acesso ao DentalGO quando assinatura for feita por algum método externo à plataforma. Exemplo: Máquina de Cartão de Crédito em Congressos'
    },
    requiresAddressHelpLabel() {
      return 'Se esta flag estiver marcada o usuário deverá informar seu endereço no momento da assinatura'
    },
    intervalTypes() {
      return ['months']
    },
    billingTriggerTypes() {
      return ['day_of_month', 'beginning_of_period', 'end_of_period']
    },
    body() {
      return {
        ...this.plan,
        collections: this.plan.collections.map(collection => collection.id),
      }
    },
    requiredBillingTriggeType() {
      if (!this.$route.params.id) {
        return this.systemParameters.defaultPaymentGateway === 'vindi'
      }

      const integrationPlans = this.plan.integrationPlans
      if (integrationPlans) {
        return integrationPlans.some(
          integrationPlan => integrationPlan.paymentGatewayType === 'vindi',
        )
      }
      return true
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      plan: {
        title: '',
        description: '',
        intervalType: 'months',
        billingTriggerType: 'day_of_month',
        billingTriggerDay: 1,
        intervalCount: 1,
        monetizationForFiliations: false,
        isManualPayment: false,
        requiresAddress: false,
        price: 0,
        status: true,
        collections: [],
        payableWith: 'credit_card',
      },
    }
  },
  methods: {
    async onSubmit() {
      const { body } = this
      const submitFunction = body.id ? plans.update : plans.create
      try {
        this.loading = true
        await submitFunction(body)
        this.$toaster.success('Plano salvo')
        this.$router.back()
      } catch (e) {
        this.$toaster.error('Não foi possível salvar o plano')
      } finally {
        this.loading = false
      }
    },
  },
  validations: {
    plan: {
      title: { required },
      description: {},
      intervalType: { required },
      billingTriggerType: {
        required: requiredIf(function() {
          return this.requiredBillingTriggeType
        }),
      },
      requiresAddress: {},
      billingTriggerDay: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(31),
      },
      intervalCount: { required, minValue: minValue(1) },
      price: { required },
      status: { required },
      payableWith: { required },
    },
  },
  async created() {
    if (!this.$route.params.id) return
    try {
      const { data } = await plans.show(this.$route.params.id)
      this.plan = data
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },
}
</script>
